/* eslint-disable */
import { endpoints } from '../Constants';
import { authHeader } from '../Helpers';
import handleResponse from './helpers';

// Dine-in floor (flat tables grouped by a `section` label) is store-scoped, so it
// does not fit the generic list/view CRUD gateway. Endpoints:
//   GET  /retail/store/<storeId>/floor   -> { storeId, tables:[...] }
//   POST /retail/store/<storeId>/floor   -> aggregate upsert of the tables
//   PATCH /retail/table/<tableId>/status -> flip occupied / isEnabled

function getFloor({ storeId }) {
	const requestOptions = {
		method: 'GET',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
	};
	return fetch(
		`${endpoints.RETAIL_STORE_FLOOR}/${storeId}/floor`,
		requestOptions
	).then(handleResponse);
}

function saveFloor({ storeId, data }) {
	const requestOptions = {
		method: 'POST',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({ ...data }),
	};
	return fetch(
		`${endpoints.RETAIL_STORE_FLOOR}/${storeId}/floor`,
		requestOptions
	).then(handleResponse);
}

function updateTableStatus({ tableId, data }) {
	const requestOptions = {
		method: 'PATCH',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({ ...data }),
	};
	return fetch(
		`${endpoints.RETAIL_TABLE}/${tableId}/status`,
		requestOptions
	).then(handleResponse);
}

const retailFloorServices = {
	getFloor,
	saveFloor,
	updateTableStatus,
};

export default retailFloorServices;
